import React, { useState } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import CreatePage from '../../../composents/CreatePage';

const title = 'Permissions';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new permission',
	breadcrumbs: [
		{
			title: title,
			link: '/administrators/permissions',
		},
	],
};

export default function CreatePermission() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[type, setType] = useState(),
		types = [
			{
				value: 'public',
				label: 'Public',
			},
			{
				value: 'private',
				label: 'Private',
			},
		],
		methods = [
			{
				value: 'GET',
				label: 'Read all',
			},
			{
				value: 'POST',
				label: 'Create',
			},
			{
				value: 'PUT',
				label: 'Update',
			},
			{
				value: 'DELETE',
				label: 'Delete',
			},
			{
				value: 'GET',
				label: 'details',
			},
		],
		groups = [
			{
				value: 'countries',
				label: 'Countries',
			},
			{
				value: 'cities',
				label: 'Cities',
			},
			{
				value: 'entities',
				label: 'HD-entity',
			},
			{
				value: 'clients',
				label: 'Clients',
			},
			{
				value: 'consumers',
				label: 'Consumers',
			},
			{
				value: 'zones',
				label: 'Zones',
			},
			{
				value: 'meters',
				label: 'Meters',
			},
			{
				value: 'restrictions',
				label: 'Restrictions',
			},
			{
				value: 'subscriptions',
				label: 'Subscription',
			},
			{
				value: 'cards',
				label: 'Water cards',
			},
			{
				value: 'consumptions',
				label: 'Consumptions',
			},
			// {
			// 	value: 'general stats',
			// 	label: 'General stats',
			// },
			// {
			// 	value: 'accounting',
			// 	label: 'Accounting',
			// },
			{
				value: 'permissions',
				label: 'Permissions',
			},
			{
				value: 'groups',
				label: 'Groups',
			},
			{
				value: 'users',
				label: 'Users',
			},
			{
				value: 'agents',
				label: 'Agents',
			},
		];

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		setLoader(true);
		setErrors({});
		let res = await resources.permission
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/administrators/permissions');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	const getMethods = () => {
		let methodIn = [];
		if (type) {
			methodIn = [...methods];
			// if (type.value === 'meters' || type.value === 'cards') {
			// 	methodIn = [
			// 		...methodIn,
			// 		{
			// 			value: 'PUT',
			// 			label: 'activate/deactivate',
			// 		},
			// 	];
			// }

			// if (type.value === 'cards') {
			// 	methodIn = [
			// 		...methodIn,
			// 		{
			// 			value: 'PUT',
			// 			label: 'top up',
			// 		},
			// 	];
			// }
		}

		return methodIn;
	};

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="title"
									className="mb-3"
									error={errors['title']}
									required
								>
									Permission title
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Permission type{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										name="type"
										options={types}
										isSearchable
										isClearable={false}
										className={
											errors['type'] ? ' is-invalid' : ''
										}
									/>
									{errors['type'] && (
										<div className="invalid-feedback">
											{errors['type']}
										</div>
									)}
								</div>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Permission category{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										name="group"
										options={groups}
										onChange={setType}
										isSearchable
										isClearable={false}
										className={
											errors['group'] ? ' is-invalid' : ''
										}
									/>
									{errors['group'] && (
										<div className="invalid-feedback">
											{errors['group']}
										</div>
									)}
								</div>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Permission Method{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										name="method"
										options={getMethods()}
										isSearchable
										isClearable={false}
										className={
											errors['method']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['method'] && (
										<div className="invalid-feedback">
											{errors['method']}
										</div>
									)}
								</div>

								<Field
									name="uri"
									className="mb-3"
									error={errors['uri']}
									required
								>
									Uri
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
